export const getColumnSortLabel = column => column.label || column.name || '';

export const shouldDisplayViewColumn = column =>
  column.display !== 'excluded' && column.viewColumns !== false;

export const getSortedViewColumns = columns =>
  columns
    .map((column, index) => ({ column, index }))
    .filter(({ column }) => shouldDisplayViewColumn(column))
    .sort((firstColumn, secondColumn) =>
      getColumnSortLabel(firstColumn.column).localeCompare(
        getColumnSortLabel(secondColumn.column),
        undefined,
        { sensitivity: 'base' }
      )
    );
